import React from 'react'
import Head from '../partials/Head';
import TheLoop from '../partials/TheLoop';
import Pager from '../partials/Pager';
import Foot from '../partials/Foot';
import ProfileHolder from '../partials/ProfileHolder';
import {Provider} from '../context/Context';

const Archive = (props) => {

  let pageTitle = 'Sitemap';

  return (
    <Provider router={props} >
    <div className="archive">
      <Head></Head>
      <div className="content-area">
      <h1>{pageTitle}</h1>
      <p>Here's a dump of random useful snippets of information, and my small contribution to the internet! Quite a lot of this might be outdated now, but seems to get traffic so I've kept it online.</p>
      <TheLoop></TheLoop>
      <Pager></Pager>
      <ProfileHolder />
      </div>
      <Foot></Foot>
    </div>
    </Provider>
  )

}
export default Archive